'use strict'

import {Toast, Indicator} from 'mint-ui'
import {findIndex} from 'lodash/findIndex'
import jsBridge from '../jsBridge'
import sensors from 'sa-sdk-javascript'
import axios from '../http/axios'

export default {
    //简短的消息提示框
    prompt(a = '提示', b = 'middle', c = '3000', d = '', e = '') {
        return Toast({
            message: a,
            position: b,
            duration: c,
            className: d,
            iconClass: e,
        })
    },
    // 调用app端关闭webview
    closeWebview() {
        jsBridge.closeWebView()
        return
    },
    // 获取url参数
    getQueryString(key) {
        var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
        try {
            var r = window.location.href.split('?')[1].match(reg)
            if (r != null) return decodeURI(r[2])
            return ''
        } catch (err) {
            // console.log(err)
        }
    },
    // 将url参数处理成成对象,并保存到session中
    setURLQueryString() {
        try{
            const search = window.location.href.split('?')[1].substr(0) // a=11&b=22&c=33
            const search1 = search.split('&') // [a=11, b=22, c=33]
            const search2 = {}
            search1.forEach((value, index) => {
                search2[value.split('=')[0]] = value.split('=')[1]
            })
            if(search2) {
                const search2JSON = search2 && JSON.stringify(search2)
                sessionStorage.setItem('urlQueryString', search2JSON)
            }
            return search2
        }catch(e) {
            console.log(e)
        }
    },
    getQueryStringForHash(key) {
        var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'g')
        try {
            var r = window.location.hash.split('?')[1].match(reg)
            if (r != null) return decodeURI(r[2])
            return ''
        } catch (err) {
            // console.log(err)
        }
    },
    getQueryStringForRepeatParams(key) {
        try {
            let params = window.location.hash.split('?')[1]
            let keyAndValues = params.split('&')
            let obj = {}
            keyAndValues.forEach(item => {
                let paramItem = item.split('=')
                if (paramItem[1] !== '') {
                    obj[paramItem[0]] = paramItem[1]
                }
            })
            return obj[key]
        } catch (e) {
            return ''
        }
    },
    /**
     * 功能:从微信分享卡片中获取url参数
     * 分享到微信中的链接会自动添加参数如?from=singlemessage
     * 如 http://39.107.98.106:8000/h5app4/dist/?from=singlemessage#/preRecommendBuildPoint?rangeId=20ca9662bbc545b28d933cf4aaf1e998
     */
    getQueryStringFromWX(key) {
        let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
        try {
            let url = window.location.href
            let r = url.split('?')[url.split('?').length - 1].match(reg)
            if (r != null) return decodeURI(r[2])
            return ''
        } catch (err) {
            // console.log(err)
        }
    },
    //加载提示框
    indicator: {
        open: function (message) {
            return Indicator.open({
                text: message || '加载中...',
                spinnerType: 'snake',
            })
        },
        close: function () {
            return Indicator.close()
        },
    },
    cookie: {
        setCookie(name, value, time) {
            var Days = time || 1
            //var strsec = getsec(time);
            var exp = new Date()
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
            document.cookie = name + '=' + escape(value) + ';expires=' +
                exp.toGMTString()
        },
        getsec(str) {
            var str1 = str.substring(1, str.length) * 1
            var str2 = str.substring(0, 1)
            if (str2 == 's') {
                return str1 * 1000
            } else if (str2 == 'h') {
                return str1 * 60 * 60 * 1000
            } else if (str2 == 'd') {
                return str1 * 24 * 60 * 60 * 1000
            }
        },
        getCookie(name) {
            var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
            if (arr = document.cookie.match(reg))
                return unescape(arr[2])
            else
                return null
        },
        delCookie() {
            var exp = new Date()
            exp.setTime(exp.getTime() - 1)
            var cval = getCookie(name)
            if (cval != null)
                document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
        },
    },
    /**
     * 改变app头部文字颜色和背景颜色
     * @param textColor 文字颜色 默认 #696969
     * @param bgColor 背景颜色 默认 #FFFFFF
     * tip：参数色值需要带 #
     */
    changeAppBgColor(textColor, bgColor) {
        // if (window.changeTitleBgColor) {
        //     window.changeTitleBgColor.setTitleColor(textColor, bgColor)
        //     // window.changeTitleBgColor.setTitleColor('#696969', '#FFFFFF')
        // }
        if (jsBridge.ishaveNativeMethod('setTitleColor') || window.changeTitleBgColor) {
            jsBridge.setTitleColor(textColor, bgColor)
        }
        if (top.h5car) {
            top.h5car.changeTitleBgColor(textColor, bgColor)
            // top.h5car.changeTitleBgColor('#696969', '#FFFFFF')
        }
    },
    /**
     * 改变app头部返回按钮颜色
     * 按钮（返回及关闭）背景类型 type ( Int 类型 1：深色 2：浅色。)
     * @param type
     */
    setBackBg(type) {
        if (type) {
            jsBridge.setBackBg(type)
        }
        if (top.h5car) {
            top.h5car.setBackBg && top.h5car.setBackBg(type)
        }
    },
    /**
     * 数据上报接口  也称埋点
     * @param params
     * @param params.pageID
     * @param params.widgetId
     * @param params.actionTypeID  曝光 02， 点击01
     * @param params.data
     */
    appReport(params) {
        return;
        let {pageID, widgetId, actionTypeID, data} = params
        if (!pageID || !widgetId || !actionTypeID || !data) {
            console.error('数据上报 缺少参数')
            return
        }
        if (!jsBridge.getReportInfo()) return
        var dataReport = JSON.parse(jsBridge.getReportInfo())
        var reportDdata = {
            extraDeviceId: dataReport.extraDeviceId,
            deviceId: dataReport.deviceId,
            appVersion: dataReport.appVersion,
            deviceType: dataReport.deviceType,
            appId: dataReport.appId,
            versionId: dataReport.versionId,
            marketId: dataReport.marketId,
            content: [],
            os: dataReport.os,
        }
        var reportItem = {
            adCode: dataReport.content[0].adCode,
            cityCode: dataReport.content[0].cityCode,
            lat: dataReport.content[0].lat,
            lon: dataReport.content[0].lon,
            sim: dataReport.sim,
            time: new Date().getTime(),
            sessionId: dataReport.sessionId,
            //以下为自定义字段
            pageId: pageID,
            widgetId: widgetId,
            actionTypeId: actionTypeID,
            data: data,
        }
        reportDdata.content.push(reportItem)
        var root = process.env.REPORT_ROOT
        console.log(root)
        console.log('reportDdata', reportDdata)
        // axios({
        //     method: 'post',
        //     url: root + '/dataReport/appLog',
        //     data: reportDdata,
        //     noLoading: true,
        //     dataReport: true,
        // })
    },
    /**
     * 获取数据上报api地址
     * tip:只有线上环境连接 report.shouqiev.com
     * 其他环境都连接 testreport.gfdev.cloudns.asia:88
     * 弃用 使用配置文件里面的地址 --边晖
     */
    getDataReportApi() {
        let dataReportApi = '//testreport.gfdev.cloudns.asia:88/'
        if (location.host === 'app.shouqiev.com') {
            dataReportApi = '//report.shouqiev.com/'
        }
        return dataReportApi
    },
    /**
     * 获取app的dataReport信息
     */
    getDataReport() {
        let sessionReportInfo = sessionStorage.getItem('reportInfo')
        if (sessionReportInfo) {
            sessionReportInfo = JSON.parse(sessionReportInfo)
        }
        let reportInfo = sessionReportInfo || {}
        reportInfo = jsBridge.getReportInfo()
        if (reportInfo) {
            //因为ios注入时机有问题，从第三方回到我们自己的界面注入信息获取不到，所以如果能获取到一次就存储在sessionStorage里
            sessionStorage.setItem('reportInfo', reportInfo)
            reportInfo = JSON.parse(reportInfo)
        }
        return reportInfo
    },
    /**
     * 获取app版本信息
     * 老版本 appVersion<430
     * 新版本 1000>appVersion>=430
     */
    getAppVersion() {
        let appVersion = 0
        let urlAppVersion = this.getQueryString('appVersion')
        if (urlAppVersion) {
            appVersion = Number(urlAppVersion)
        } else if (jsBridge.getReportInfo()) {
            let reportInfo = jsBridge.getReportInfo()
            reportInfo = JSON.parse(reportInfo)
            appVersion = Number(reportInfo.appVersion)
        } else {
            let sessionAppVersion = sessionStorage.getItem('appVersion')
            if (sessionAppVersion) {
                appVersion = Number(sessionAppVersion)
            } else { //如果是H5用车入口，版本号显示1000
                appVersion = 1000
            }
        }
        sessionStorage.setItem('appVersion', appVersion)
        window.appVersion = appVersion
        return appVersion
    },
    /**
     * 判断城市是否开通了智齿客服功能
     * @param cityCode
     * @returns {boolean}
     */
    isCityOpenService(cityCode) {
        var openCitys = [
            {'010': '北京'},
            {'028': '成都'},
            {'022': '天津'},
            {'029': '西安'},
            {'0591': '福州'},
        ]
        var cityIndex = openCitys.findIndex(function (el) {
            return el[cityCode]
        })
        return cityIndex > -1
    },
    /**
     * 拼接 网关地址
     * 用于判断是否是带网关的地址，如果是拼上'/h5app4'目录
     * 不带网关示例 https://app4.shouqiev.com/static/img/icon_zhiChi_user.png
     * 带网关示例  https://gateway.shouqiev.com:8443/h5app4/static/img/icon_zhiChi_user.png
     * @param url '/static/img/icon_zhiChi_user.png' 参数要求带前边的/
     * @returns {string|string}
     */
    spliceGateWayUrl(url) {
        let newUrl = ''
        if (location.origin.indexOf('gateway') >= 0
            || location.host === '39.107.98.106:8000'
            || location.host === '39.106.63.225:8000'
            || location.host === '47.94.148.4:8000'
            || location.host === '47.94.151.186:8000') { //带网关的地址拼接上 '/h5app4'
            let h5Path = '/h5app4'
            newUrl = location.origin + h5Path + url
        } else if (location.origin.indexOf('go.shouqiev.com') >= 0 ||
            location.origin.indexOf('c2c.shouqiev.com') >= 0 ||
            location.origin.indexOf('autopilot.shouqiev.com') >= 0) {
            // 新加针对h5 prego.shouqiev.com和go.shouqiev.com的地址拼接
            let h5Path = '/iframeApp4'
            newUrl = location.origin + h5Path + url
        } else {
            //非网关正常拼接
            newUrl = location.origin + url
        }
        return newUrl
    },
    /**
     * token  //token
     * 请求需要携带的token，来源:
        * 1是app放在userAgent里的token
        * 2是H5用车放在url上的token
        * 3 异常，在首约app中 url会被塞他们的token
     * @type {string}
     */
    getToken(isFromGoFunSelect=false) {
        let token = ''
        //app放在userAgent里的token
        let ua = top.navigator.userAgent
        if (ua.indexOf('###') > -1) {
            token = JSON.parse(
                ua.split('###')[0]).token
        }
        //H5用车放在url上的token
        if (this.getQueryString('token')) {
            token = this.getQueryString('token')
        }
        !isFromGoFunSelect && token && sessionStorage.setItem('gofun_token', token)
        if (!token && sessionStorage.getItem('gofun_token')) {
            token = sessionStorage.getItem('gofun_token')
        }
        if (!token && localStorage.getItem('gofun_token')) {
            token = localStorage.getItem('gofun_token')
        }
        if (!token && !sessionStorage.getItem('gofun_token')) {
            sessionStorage['gofun_token'] = ''
        }
        console.log('token::', token)
        return token
    },
    /**
     * 获取app内userAgent里的token
     */
    getAppToken() {
        let token = '';
        //app放在userAgent里的token
        let ua = top.navigator.userAgent;
        if (ua.indexOf('###') > -1) {
            token = JSON.parse(ua.split('###')[0]).token
        }
        console.log('token::::getapp', token)
        return token
    },
    getUserId() {
        let userId = this.getQueryString('userId') || ''
        if (userId) {
            sessionStorage.setItem('userId', userId)
        } else {
            const sessionUserId = sessionStorage.getItem('userId')
            if (sessionUserId) {
                userId = sessionUserId
            }
        }
        return userId
    },
    /**
     * 判断是否是 app内的H5引用，来自H5用车的有top.h5car
     */
    isFromH5() {
        return Boolean(top.h5car)
    },
    /**
     * 判断是否来自App,来自app的userAgent里有gofun字符串
     * paymentSource === 'paymentSource' 代表来自众包
     */
    isFromApp() {
        let fromApp = top.navigator.userAgent.indexOf('gofun') > -1 || this.getQueryString('paymentSource') === 'crowdsource'
        return fromApp
    },
    /**
     * 判断是否来自微信小程序webview
     * https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
     * window.__wxjs_environment === 'miniprogram'
     */
    isFromWxMiniprogramWebView() {
        // return window.__wxjs_environment === 'miniprogram'
        // if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
        //     return true
        // } else {
        //     return false
        // }
        return /MicroMessenger/.test(window.navigator.userAgent);
    },
    /**
     * 判断是否来自支付宝小程序webview
     * https://opendocs.alipay.com/mini/component/mg7rvg
     */
    isFromAlipayMiniprogramWebview() {
        // if (my && my.getEnv) {
        //     return true
        // } else {
        //     return false
        // }
        return /AlipayClient/.test(window.navigator.userAgent);
    },
    /**
     * 问题上报后返回各自来源的操作
     * @param feedbackSource
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_F * 首页      *   回到首页
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_J * 行程中     *  关闭webview
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_C * 客服中心   *  回到客服中心
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_G * 停车费     *  关闭webview
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_I * 取车中     *  关闭webview
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_A * 取消订单   *   回首页
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_B * 5分钟结单  *  回到首页
     * CUSTOMERSERVICE_REPORT_TEMPLATE_E_D * 我的行程   *  关闭webview
     */
    reportBackSource(feedbackSource = 'CUSTOMERSERVICE_REPORT_TEMPLATE_E_C') {
        const feedBackSourceMap = {
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_F: this.toHomeForAll.bind(this),        // * 首页      *   回到首页
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_J: this.closeWebViewForAll.bind(this),  // * 行程中     *  关闭webview
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_C: this.toMyServiceForAll.bind(this),   // * 客服中心   *  回到客服中心
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_G: this.closeWebViewForAll.bind(this),  // * 停车费     *  关闭webview
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_I: this.closeWebViewForAll.bind(this),  // * 取车中     *  关闭webview
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_A: this.toHomeForAll.bind(this),        // * 取消订单   *   回首页
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_B: this.toHomeForAll.bind(this),        // * 5分钟结单  *  回到首页
            CUSTOMERSERVICE_REPORT_TEMPLATE_E_D: this.closeWebViewForAll.bind(this),  // * 我的行程   *  关闭webview
        }
        if (feedBackSourceMap[feedbackSource]) {
            setTimeout(() => {
                feedBackSourceMap[feedbackSource]()
            }, 2000)
        } else {
            setTimeout(() => {
                this.closeWebViewForAll.call(this)
            }, 2000)
        }
    },
    /**
     * try catch封装
     * @param fnTry
     * @param fnCatch
     */
    tryCatch(fnTry, fnCatch) {
        try {
            fnTry && fnTry()
        } catch (e) {
            console.error(e)
            fnCatch && fnCatch()
        }
    },
    //弹出登录页面
    openLogin(setting) {
        console.log('=== openLogin ===')
        if (this.isFromApp()) {
            jsBridge.showLoginView({...setting})
        } else {
            Toast('登录信息失效，请重新登录')
        }
    },
    /**
     * 限制emoji表情,textArea不可以输入表情
     * @param itemId input或者textArea的id
     */
    checkEmoji(itemId, _this) {
        var reg2 = /([\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF])|(\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6])|(\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0])/g
        setTimeout(() => {
            const EleContent = document.getElementById(itemId);
            if (EleContent) {
                EleContent.onkeyup = function () {
                    let isEmoji = reg2.test(_this.message)
                    if (isEmoji) {
                        Toast('暂不支持表情输入')
                        _this.message = _this.message.replace(reg2, '')
                    }
                    //最大输入200个字符，超过弹出toast提示
                    if (_this.message.trim().length >= 200) {
                        Toast('最多可输入200个字')
                    }
                }
            }
        }, 2000)
    },
    /**
     * 判断是否登录
     * @returns {boolean}
     */
    checkIsLogin() {
        let gofunToken = localStorage.getItem('gofun_token') || sessionStorage.getItem('gofun_token')
        return Boolean(gofunToken)
    },
    /**
     * 回到首页,兼容App和H5用车
     */
    toHomeForAll() {
        if (this.isFromH5()) {
            if (top.location.href.indexOf('go.shouqiev.com')) {//预发布和线上
                //prego.shouqiev.com
                //go.shouqiev.com
                top.location.href = top.location.origin
            } else {//测试环境目录有 /h5car/
                //39.107.98.106:8000/h5car/
                top.location.href = top.location.origin + '/h5car/'
            }
        }
        if (this.isFromApp()) {
            jsBridge.toHomeFuction() //app回到首页
        }
    },
    /**
     * 跳转到我的客服页面,兼容App和H5用车
     */
    toMyServiceForAll() {
        let appUrl = this.spliceGateWayUrl('/dist/#/myService')
        top.location.href = appUrl
    },
    /**
     * 回到上一个操作页面,兼容App和H5用车
     * 关闭webview
     */
    closeWebViewForAll() {
        if (this.isFromApp()) {
            this.tryCatch(() => {
                jsBridge.closeWebView() //关闭webView
            })
        }
        if (this.isFromH5()) {
            history.back()
        }
    },
    /**
     * 通过app获取cityCode
     * @returns {*}
     */
    getAppCityCode() {
        if (jsBridge.ishaveNativeMethod('getReportInfo') || window.h5bridge || window.dataReport) {
            return JSON.parse(jsBridge.getReportInfo()).content[0].cityCode;
        }
        if (this.getQueryString('cityCode')) {
            return this.getQueryString('cityCode')
        }
        return ''
    },
    /**
     * 计算两组坐标之间的距离
     * approx distance between two points on earth ellipsoid
     * @param {Object} lat1
     * @param {Object} lng1
     * @param {Object} lat2
     * @param {Object} lng2
     */
    getFlatternDistance(lat1, lng1, lat2, lng2) {
        console.log(lat1)
        console.log(lng1)
        console.log(lat2)
        console.log(lng2)
        var EARTH_RADIUS = 6378137.0;    //单位M
        var PI = Math.PI;

        function getRad(d) {
            return d * PI / 180.0;
        }

        var f = getRad((lat1 + lat2) / 2);
        var g = getRad((lat1 - lat2) / 2);
        var l = getRad((lng1 - lng2) / 2);
        var sg = Math.sin(g);
        var sl = Math.sin(l);
        var sf = Math.sin(f);
        var s, c, w, r, d, h1, h2;
        var a = EARTH_RADIUS;
        var fl = 1 / 298.257;
        sg = sg * sg;
        sl = sl * sl;
        sf = sf * sf;
        s = sg * (1 - sl) + (1 - sf) * sl;
        c = (1 - sg) * (1 - sl) + sf * sl;
        w = Math.atan(Math.sqrt(s / c));
        r = Math.sqrt(s * c) / w;
        d = 2 * w * a;
        h1 = (3 * r - 1) / 2 / c;
        h2 = (3 * r + 1) / 2 / s;
        return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
    },
    // 获得字符串中字符长度
    getCharacterLength(val) {
        var str = new String(val);
        var bytesCount = 0;
        for (var i = 0, n = str.length; i < n; i++) {
            var c = str.charCodeAt(i);
            if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                bytesCount += 1;
            } else {
                bytesCount += 2;
            }
        }
        return bytesCount
    },
    /**
     * 动态加载JS
     * @param {string} url 脚本地址
     * @param {function} callback  回调函数
     */
    loadScriptFile(url, callback) {
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        if (typeof (callback) == 'function') {
            script.onload = script.onreadystatechange = function () {
                if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
                    callback();
                    script.onload = script.onreadystatechange = null;
                }
            };
        }
        head.appendChild(script);
    },
    // 微信js分享
    wxJsShare(shareMsg) {
        var uAgent = navigator.userAgent;
        var isAndroid = uAgent.indexOf("Android") > -1 || uAgent.indexOf("Adr") > -1;  // android终端
        var isiOS = !!uAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  // iOS终端
        if (isAndroid) {
            parent.share.wxShareWithTitleDescLink(shareMsg.title, shareMsg.link, shareMsg.desc);
            return;
        }
        parent.share.wxShareWithTitleDescLink(shareMsg.title, shareMsg.desc, shareMsg.link);
    },
    /**
     * 获取api url地址
     * @returns {string}
     */
    getApiUrl() {
        var root = process.env.API_ROOT
//如果是测试环境,baseUrl改成域名地址
        if (process.env.NODE_ENV === 'dev') {
            root = location.origin + '/backendapi'
        }
        if (process.env.NODE_ENV === 'testing') {
            if (location.href.indexOf('localhost') > -1) {
                root = process.env.API_ROOT
            } else {
                // API_ROOT: '"//39.106.63.225:8000"', //28网关
                // API_ROOT: '"//39.107.98.106:8000"', //159网关
                // API_ROOT: '"//47.94.148.4:8000"', //197网关
                // root = location.origin + '/api'
                root = location.origin
            }
        }
        if (process.env.NODE_ENV !== 'testing' && top.h5car) {
            root = process.env.API_ROOT_H5CAR
        }
        if (location.origin === 'https://c2c.shouqiev.com') {
            root = process.env.API_ROOT_C2C
        }
        if (location.origin === 'https://autopilot.shouqiev.com') {
            root = process.env.API_ROOT_Autopilot
        }
        if (location.origin === 'https://preapp4.shouqiev.com') {
            root = 'https://preapp4.shouqiev.com/backendapi'
        }
        if (location.origin === 'https://app4.shouqiev.com') {
            root = 'https://app4.shouqiev.com/backendapi'
        }
        if (location.origin === 'http://app510.51gofunev.com' || location.origin === 'https://app510.51gofunev.com') {
            root = 'http://app510.51gofunev.com/backendapi'
        }
        if (location.origin === 'http://test-app5.shouqiev.com' || location.origin === 'https://test-app5.shouqiev.com') {
            root = 'http://test-app5.shouqiev.com/backendapi'
        }
        if (location.origin === 'http://app520.51gofunev.com' || location.origin === 'https://app520.51gofunev.com') {
            root = 'http://app520.51gofunev.com/backendapi'
        }
        if (location.origin === 'https://preapp5.shouqiev.com') {
            root = 'https://preapp5.shouqiev.com/backendapi'
        }
        if (location.origin === 'https://app5.shouqiev.com') {
            root = 'https://app5.shouqiev.com/backendapi'
        }
        if (location.origin === 'https://app5share.shouqiev.com') {
            root = 'https://app5share.shouqiev.com/backendapi'
        }
        if (location.origin === 'https://app5share1.shouqiev.com') {
            root = 'https://app5share1.shouqiev.com/backendapi'
        }
        if (location.origin === 'https://app5share2.shouqiev.com') {
            root = 'https://app5share2.shouqiev.com/backendapi'
        }
        return root
    },
    /**
     * 获取app内app4项目的url地址
     */
    getApp4HtmlUrl() {
        let NODE_ENV = process.env.NODE_ENV
        if (NODE_ENV === 'dev') {
            let root = location.origin + '/api'
        }
        let {host} = location
        let apiUrl = ''
        let app4Url = ''
        let h5carUrl = ''
        switch (host) {
            //网关28环境
            case '39.106.63.225:8000':
                apiUrl = '//39.106.63.225:8000'
                app4Url = '//39.106.63.225:8000/h5app4/dist/#/'
                break;
            //网关159环境
            case '39.107.98.106:8000':
                apiUrl = '//39.107.98.106:8000'
                app4Url = '//39.107.98.106:8000/h5app4/dist/#/'
                break;
            //网关197环境
            case '47.94.148.4:8000':
                apiUrl = '//47.94.148.4:8000'
                app4Url = '//47.94.148.4:8000/h5app4/dist/#/'
                break;
            //网关186环境
            case '47.94.151.186:8000':
                apiUrl = '//47.94.151.186:8000'
                app4Url = '//47.94.151.186:8000/h5app4/dist/#/'
                break;
            //网关预发布环境
            case 'pregatewayapi.shouqiev.com:8443':
                apiUrl = '//pregatewayapi.shouqiev.com:8443'
                app4Url = '//pregatewayapi.shouqiev.com:8443/h5app4/dist/#/'
                break;
            //网关生产环境
            case 'gateway.shouqiev.com:8443':
                apiUrl = '//gateway.shouqiev.com:8443'
                app4Url = '//gateway.shouqiev.com:8443/h5app4/dist/#/'
                break;
            //域名预发布环境
            case 'preapp4.shouqiev.com':
                apiUrl = '//preapp4.shouqiev.com/backendapi'
                app4Url = '//preapp4.shouqiev.com/dist/#/'
                break;
            //域名生产环境
            case 'app4.shouqiev.com':
                apiUrl = '//app4.shouqiev.com/backendapi'
                app4Url = '//app4.shouqiev.com/dist/#/'
                break;
            //H5用车引用预发布环境
            case 'http://prego.shouqiev.com':
                apiUrl = '//prego.shouqiev.com/backendapi'
                app4Url = '//prego.shouqiev.com/iframeApp4/dist/#/'
                h5carUrl = '//prego.shouqiev.com/#/'
                break;
            //H5用车引用生产环境
            case 'go.shouqiev.com':
                apiUrl = '//go.shouqiev.com/backendapi'
                app4Url = '//go.shouqiev.com/iframeApp4/dist/#/'
                h5carUrl = '//go.shouqiev.com/#/'
                break;
            //自动驾驶引用生产环境
            case 'autopilot.shouqiev.com':
                apiUrl = '//autopilot.shouqiev.com/backendapi'
                app4Url = '//autopilot.shouqiev.com/iframeApp4/dist/#/'
                h5carUrl = '//autopilot.shouqiev.com/#/'
                break;
            //app5项目测试环境
            case 'app510.51gofunev.com':
                apiUrl = '//app510.51gofunev.com/backendapi'
                app4Url = '//app510.51gofunev.com/dist/#/'
                break;
            //app5项目域名预发布环境
            case 'preapp5.shouqiev.com':
                apiUrl = '//preapp5.shouqiev.com/backendapi'
                app4Url = '//preapp5.shouqiev.com/dist/#/'
                break;
            //app5项目域名生产环境
            case 'app5.shouqiev.com':
                apiUrl = '//app5.shouqiev.com/backendapi'
                app4Url = '//app5.shouqiev.com/dist/#/'
                break;
            //app5项目测试环境(新)
            case 'test-app5.shouqiev.com':
                apiUrl = '//test-app5.shouqiev.com/backendapi'
                app4Url = '//test-app5.shouqiev.com/dist/#/'
                break;
            default:
                apiUrl = '//gateway.shouqiev.com:8443'
                app4Url = '//gateway.shouqiev.com:8443/h5app4/dist/#/'
                h5carUrl = '//autopilot.shouqiev.com/#/'
        }
    },
    /**
     * 判断是否为微信环境
     */
    checkIsWeixin() {
        let ua = window.navigator.userAgent.toLowerCase();
        let isWeixin = (ua.match(/MicroMessenger/i) + '') === 'micromessenger';
        if (isWeixin) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 判断是否为微博环境
     */
    checkIsWeBo() {
        let ua = window.navigator.userAgent.toLowerCase();
        let isWeibo = (ua.match(/WeiBo/i) + '') === 'weibo';
        if (isWeibo) {
            return true;
        } else {
            return false;
        }
    },
    // 判断是否在GoFun app环境里
    checkInApp() {
        const isInApp = navigator.userAgent.includes('gofun');
        return isInApp
    },
    // 判断是否在首汽约车 app环境里
    checkIsSQYC() {
        const isSQYC = navigator.userAgent.includes('SQYC');
        return isSQYC
    },
    // 打开网页的方式-在app中要用app的方法
    openUrl(url, shouldHideNavBar = false) {
        console.log(url)
        if (this.checkInApp()) {
            console.log('app中')
            jsBridge.appOpenUrl(url,shouldHideNavBar)
        } else {
            window.location.href = url
        }
    },
    /**
     * 判断是否为ios系统
     */
    checkIsIOS() {
        const uAgent = navigator.userAgent;
        const isAndroid = uAgent.indexOf("Android") > -1 || uAgent.indexOf("Adr") > -1;  // android终端
        const isiOS = !!uAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  // iOS终端
        return isiOS
    },
    /**
     * 判断是否为android系统
     */
    checkIsAndroid() {
        const uAgent = navigator.userAgent;
        const isAndroid = uAgent.indexOf("Android") > -1 || uAgent.indexOf("Adr") > -1;  // android终端
        const isiOS = !!uAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  // iOS终端
        return isAndroid
    },
    /**
     * 获取用户的adCode,实际物理城市定位
     * @returns {string}
     */
    getAdCode() {
        let adCode = ''
        let urlAdCode = this.getQueryString('adCode')
        if (urlAdCode) {
            adCode = urlAdCode
        } else {
            let dataReport = JSON.parse(jsBridge.getReportInfo())
            if (dataReport) {
                adCode = dataReport.content[0].adCode
            }
        }
        return adCode
    },
    /**
     * 获取客服电话号码
     */
    getServiceNumber() {
        return axios({
            method: 'post',
            url: '/app/startUp.json',
            noLoading: true,
        }).then(resp => {
            let {data} = resp
            let {code, modelData} = data
            if (code === 200) {
                return modelData.phone
            } else {
                return ''
            }
        })
    },
    /**
     * 校验手机号或固定电话
     */
    checkPhoneAndMobile(phoneNumber) {
        if (phoneNumber) {
            // let phonePattern = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/ // 固定电话正则
            let mobilePattern = /^(1[0-9]{10})$/ // 手机号正则
            if (mobilePattern.test(phoneNumber)) {
                return true;
            } else {
                return false;
            }
        }
        return false
    },
    /**
     * 高德获取定位信息
     * cityCode和cityName
     * 注意要在https协议下才可以正常使用，http授权很大概率会被拒绝
     */
    getLocation(showToast=true) {
        console.time('高德定位');
        return new Promise((resolve, reject) => {
            let amapScript = document.createElement('script');
            amapScript.src = '//webapi.amap.com/maps?v=1.4.8&key=228a2d3b4f2c142386aa8b6ad900df52';
            document.body.append(amapScript);
            amapScript.onload = () => {
                AMap.plugin('AMap.Geolocation', function () {
                    var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：5s
                        buttonPosition: 'RB',    //定位按钮的停靠位置
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点

                    });
                    geolocation.getCurrentPosition(function (status, result) {
                        if (status === 'complete') {
                            console.log('定位成功', result);
                            console.timeEnd('高德定位');
                            resolve(result);
                        } else {
                            showToast && Toast('获取定位失败');
                            console.log('定位失败', result);
                            console.timeEnd('高德定位');
                            reject(result)
                        }
                    });
                });
            }
        })
    },
    /**
     * 添加神策埋点
     * @param: eventName 事件名称
     * @param: eventParams 参数
     */
    addSensorsTrack(eventName, eventParams = {}) {
        try {
            sensors.track(eventName, eventParams)
        } catch (e) {
            console.error(e)
        }
    },
    /**
     * 神策代码埋点触发元素点击事件
     * 文档 https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all_use-7545350.html#id-.%E5%85%A8%E5%9F%8B%E7%82%B9(Web)v1.13-%E4%BB%A3%E7%A0%81%E5%9F%8B%E7%82%B9%E8%A7%A6%E5%8F%91%E5%85%83%E7%B4%A0%E7%82%B9%E5%87%BB%E4%BA%8B%E4%BB%B6
     * @param eleTarget 点击的dom元素
     * @param customProps 自定义属性
     * @param fnCallback 回调
     */
    addSensorsWebClick(eleTarget, customProps, fnCallback) {
        sensors.quick('trackAllHeatMap', eleTarget, {
            customEvent: '$WebClick',
            $element_content: customProps,
        }, fnCallback);
    },
    /**
     * 过滤表情符
     */
    filterEmojiNew(str) {
        const rangesReg = /([\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF])|(\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6])|(\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0])/ig
        if (rangesReg.test(str)) {
            Toast('暂不支持表情输入')
            str = str.replace(rangesReg, "")
        }
        return str
    },
    /**
     * 是否来自支付宝
     */
    isFromAlipay() {
        if (navigator.userAgent.indexOf('AlipayClient') > -1) {
            return true
        } else {
            return false
        }
    },
    /**
     * 是否来微信
     */
    isFromWeChat() {
        let ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true
        } else {
            return false
        }
    },
    /**
     * 是否来抖音
     */      
    isFromDouyinMiniProgram() {
        const userAgent = navigator.userAgent;
        if (userAgent.includes('aweme') || userAgent.includes('ToutiaoMicroApp')) {
            return true; // 来自抖音小程序
        }
        return false; // 不来自抖音小程序
    },
    /**
     * 是否来自抖音
     */
    isFromDouYin() {
        if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
            return true
        } else {
            return false
        }
    },

    /**
     * connect查询客服能力接口
     */
    customerEntrance(data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/api3_oss/customer/customerEntrance.json',
                data: data,
                noLoading: true,
                requestJson: true,
            }).then(resp => {
                resolve(resp)
            })
        })

    },
    /**
     * 延时关闭当前webview
     * 用于h5跳到原生页面，原生页面不想返回到H5页面的情况
     */
    setTimeOutCloseWebview() {
        // android会先打开新的原生页面 延时关掉后台的webview
        if (this.checkIsAndroid()) {
            setTimeout(() => {
                this.closeWebview()
            }, 2000);
        }
        // ios 延时关闭会关闭新打开的原生页面
        if (this.checkIsIOS()) {
            this.closeWebview()
        }
    },

    /**
     * 获取app5项目对应的host
     * 如果二级域名中有10、20、30那就是测试环境
     * 有pre代表预发布环境
     * https非预发布代表生产
     */
    getShareUrl() {
        let app5Url = 'https://share.shouqiev.net';
        let hostname = location.hostname;
        if (hostname.includes('10')) {
            app5Url = 'http://share10.51gofunev.com'
        } else if (hostname.includes('20')) {
            app5Url = 'http://share20.51gofunev.com'
        } else if (hostname.includes('30')) {
            app5Url = 'http://share30.51gofunev.com'
        } else if (hostname.includes('pre')) {
            app5Url = 'https://preshare.shouqiev.net'
        } else if (hostname.includes('test')) {
            app5Url = 'http://test-share.shouqiev.com'
        } 
        return app5Url
    },

    /**
     * 拖动元素
     * {
     *   idName: 拖动元素的id
     *   moveDirection: 移动方向（默认XY轴方向，1-X轴方向，2-Y轴方向）
     *   rangeLeft: X轴可移动的范围[minLeft, maxLeft]
     *   rangeTop: Y轴可以的范围[minTop, maxTop]
     * }
     */
    dragDiv(paramObj) {
        let oL, oT
        const drag = document.getElementById(paramObj.idName)
        //限制最小最大宽高，不让滑块出去
        let minLeft = 0
        let minTop = 0
        let maxLeft = document.body.clientWidth - drag.offsetWidth;
        let maxTop = document.body.clientHeight - drag.offsetHeight;

        if (paramObj.rangeLeft && paramObj.rangeLeft.length >= 2) {
            minLeft = paramObj.rangeLeft[0] > 0 ? paramObj.rangeLeft[0] : 0
            maxLeft = paramObj.rangeLeft[1] < maxLeft ? paramObj.rangeLeft[1] : maxLeft
        }

        if (paramObj.rangeTop && paramObj.rangeTop.length >= 2) {
            minTop = paramObj.rangeTop[0] > 0 ? paramObj.rangeTop[0] : 0
            maxTop = paramObj.rangeTop[1] < maxTop ? paramObj.rangeTop[1] : maxTop
        }

        //手指触摸开始，记录div的初始位置
        drag.addEventListener('touchstart', function (e) {
            let ev = e || window.event;
            let touch = ev.targetTouches[0];
            oL = touch.clientX - drag.offsetLeft;
            oT = touch.clientY - drag.offsetTop;
        });
        //触摸中的，位置记录
        drag.addEventListener('touchmove', function (e) {
            let ev = e || window.event;
            let touch = ev.targetTouches[0];
            let oLeft = touch.clientX - oL;
            let oTop = touch.clientY - oT;

            if (oLeft < minLeft) {
                oLeft = minLeft;
            } else if (oLeft >= maxLeft) {
                oLeft = maxLeft;
            }

            if (oTop < minTop) {
                oTop = minTop;
            } else if (oTop >= maxTop) {
                oTop = maxTop;
            }

            if (paramObj.moveDirection === 1) { // X轴方向移动
                drag.style.right = 'auto';
                drag.style.left = oLeft + 'px';
            } else if (paramObj.moveDirection === 2) { // Y轴方向移动
                drag.style.bottom = 'auto';
                drag.style.top = oTop + 'px';
            } else { // XY轴方向都可以移动
                drag.style.right = 'auto';
                drag.style.bottom = 'auto';
                drag.style.left = oLeft + 'px';
                drag.style.top = oTop + 'px';
            }
            e.preventDefault(); // 阻止默认事件-ios效果最佳
        });
        //触摸结束时的处理
        drag.addEventListener('touchend', function () {

        });
    },
    toLogin(url) {
        // 兼容商城挂到首汽
        if (this.checkInApp()) {
            this.openLogin()
        } else {
            let redirect = encodeURIComponent(url || window.location.href)
            window.location.href = `${process.env.NODE_ENV === 'dev'?'/#/':'/dist/#/'}login?redirectUrl=${redirect}`
        }
    },
    isWx() {
        // 判断在微信浏览器中还是微信小程序webview中
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return new Promise(resolve => {
            wx.miniProgram.getEnv(function(res) {
              if (res.miniprogram) {
                resolve("mini-wx");
              } else {
                resolve("wx");
              }
            });
          });
        } else {
          return new Promise(resolve => {
            resolve("no-wx");
          });
        }
    }
}



// WEBPACK FOOTER //
// src/libs/utils/utils.js